var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkToggleDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.96094 0.25V0.289062C9.19531 0.289062 9.46875 0.289062 9.70312 0.289062C9.97656 0.328125 10.2109 0.523438 10.25 0.796875C10.3281 1.07031 10.2109 1.34375 9.97656 1.46094C7.86719 2.63281 6.46094 4.89844 6.46094 7.4375C6.46094 11.2656 9.54688 14.3125 13.3359 14.3125C13.7266 14.3125 14.1172 14.3125 14.5078 14.2344C14.7812 14.1953 15.0547 14.3125 15.1719 14.5469C15.2891 14.8203 15.25 15.0938 15.0547 15.2891C13.4922 16.8125 11.3438 17.75 8.96094 17.75C4.15625 17.75 0.25 13.8438 0.25 9C0.25 4.19531 4.15625 0.25 8.96094 0.25Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkToggleDisabled);
export default __webpack_public_path__ + "static/media/dark_toggle_disabled.781cb81b46edf1001754dbbba7934c6c.svg";
export { ForwardRef as ReactComponent };